<template>
  <div class="page--at-page" style="display: grid;">
    <a href="https://at.govt.nz/bus-train-ferry/#!/journey-planner" class="page-block">
      <div class="page-block__image" style="background-image: url(https://at.govt.nz/media/1983391/findroute-2x.webp);"></div>
      <div class="page-block__heading">Find the best route</div>
    </a>
    <router-link to="/transport/live-departures" class="page-block">
      <div class="page-block__image" style="background-image: url(https://at.govt.nz/media/1983396/realtime-2x.webp)"></div>
      <div class="page-block__heading">Live departures</div>
    </router-link>
    <a href="https://at.govt.nz/bus-train-ferry/#!/timetables" class="page-block">
      <div class="page-block__image" style="background-image: url(https://at.govt.nz/media/1983546/journey_notification.webp)"></div>
      <div class="page-block__heading page-block__heading__smaller">Bus Train Ferry timetables</div>
    </a>
    <router-link v-if="!this.isiOS" to="/transport/my-at-hop" class="page-block">
      <div class="page-block__image" style="background-image: url(https://at.govt.nz/media/1983394/hopbalance-2x.webp)"></div>
      <div class="page-block__heading">My AT HOP & App Downloads</div>
    </router-link>
    <router-link to="/road-maintenance/Mt Eden" class="page-block">
      <div class="page-block__image" style="background-image: url(https://ucarecdn.com/58ba341a-9eea-409b-900e-b5aded6d9704/Group1.png)"></div>
      <div class="page-block__heading page-block__heading__smaller">Line Status & Service Announcements</div>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'Transport',
  data: function() {
    return {
      isiOS: false
    }
  },
  mounted() {
    this.getDeviceType()
  },
  methods: {
    getOSType() {
      if (/(Android)/i.test(navigator.userAgent)) {
        return 'Android'
      } else if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
        return 'iOS'
      }
    },
    getDeviceType() {
      let osType = this.getOSType()
      if (osType === 'iOS') {
        this.isiOS = true
      }
    }
  }
}
</script>

<style scoped lang="scss">
.page--at-page {
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr 1fr;
  gap: 20px;
  height: 100%;

  .page-block {
    text-align: center;
    box-shadow: 0 1rem 1rem rgb(0 0 0 / 20%);
    background-color: #328BC3;
    text-decoration: none;
    background-size: cover;
    background-repeat: no-repeat;
    position: relative;
    background-position: top center;
    display: flex;
    flex-direction: column;
    padding: 0;

    @media screen and (max-width: 600px) {
      background-position: top center;
      background-size: contain;
    }
  }

  .page-block__heading {
    color: #fff;
    line-height: 3rem;
    font-weight: 700;
    text-align: center;
    text-shadow: 0 2px 4px rgb(0 0 0 / 30%);

    padding: 1rem;
    background: #203d58;
    width: 100%;
    font-size: 2rem;
    min-height: 4rem;
    display: flex;
    justify-content: center;
    align-items: center;

    @media screen and (max-width: 600px) {
      font-size: 1rem;
    }
  }

  .page-block__image {
    flex: 1;
    background-size: contain;
    background-position: bottom;
    background-repeat: no-repeat;
    background-color: #328bc3;
    width: 100%;
  }

  .page-block__heading__smaller {
    @media screen and (max-width: 600px) {
      font-size: 0.8rem;
    }
  }

  .page-block--at-apps {
    background-size: 60%;
    background-color: #338cc5;
  }
}

</style>
